import styled from '@emotion/styled';

import { CopyButton } from 'components/buttons/copy';
import { Panel } from 'components/containers';
import IconCheckCircleOutline from 'components/icons/checkCircleOutline';
import Link from 'components/link';

export const Header = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: 14,
  fontWeight: 500,
  padding: '16px 20px',
}));

export const StyledPanel = styled(Panel)(() => ({
  padding: 0,
  '& > div': {
    padding: 0,
  },
}));

export const QRCodePanel = styled(Panel)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 30,
}));

export const Content = styled.div(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  gap: 24,
  padding: 20,
  '& > div': {
    maxWidth: 496,
    width: '100%',
  },
}));

export const Information = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  fontSize: 13,
  svg: {
    path: {
      fill: theme.colors.accent,
    },
  },
}));

export const Grid = styled.div((_) => ({
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  gap: 24,
  alignItems: 'center',
}));

export const Label = styled.div(({ theme }) => ({
  fontSize: 13,
  fontWeight: 400,
  color: theme.colors.inactive,
}));

export const LinkOverflowWrapper = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  gap: 8,
  minWidth: 0,
  maxWidth: 'calc(100% - 5px)',
  a: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  fontFamily: theme.fonts.secondary,
  fontSize: 14,
}));

export const FlexRow = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  overflow: 'hidden',
}));

export const StyledCopyButton = styled(CopyButton)(({ theme }) => ({
  minWidth: 'auto',
  svg: {
    path: {
      fill: `${theme.colors.accent}!important`,
    },
  },
}));

export const StyledIconCheckCircleOutline = styled(IconCheckCircleOutline)((props) => ({
  path: {
    fill: props.theme.colors.accent,
  },
}));
